const hasValue = (value) => value !== null && value !== undefined && value !== "";

// Minimum assessment score (%) that counts as a pass.
export const PASS_MARK = 60;

export const getStatusBadge = (status, scorePercentage) => {
    // Source of truth: a recorded score means the assessment was taken, full stop - so the
    // Result can never be "Not Taken" when a score exists, and it never depends on whether the
    // rest of the course has been completed yet (a learner can pass the assessment while other
    // modules are still in progress). PASS_MARK (60%)+ is a pass; anything lower is a fail.
    //
    // This deliberately overrides the underlying lessonStatus tracking field, which is written by
    // SCORM/xAPI module state updates and can end up stale or overwritten by unrelated modules.
    if (hasValue(scorePercentage)) {
        return Number(scorePercentage) >= PASS_MARK
            ? <span className="badge badge-success">Passed</span>
            : <span className="badge badge-danger">Failed</span>
    }

    // No score recorded - fall back to the legacy status field for older rows.
    // SCORM "passed" (2) and "completed" (4) both mean success - treat them the same here.
    if (status === 4 || status === 2) {
        return <span className="badge badge-success">Passed</span>
    }
    else if (status === 3) {
        return <span className="badge badge-danger">Failed</span>
    }
    else {
        return <span className="badge badge-warning">Assessment Not Taken</span>
    }
}

// Defends the UI against contradictory data - whatever the backend ends up reporting, these two
// badges can never disagree: a course cannot show "Completed" while its assessment shows "Not
// Taken". If that combination is ever seen, treat the course as not actually complete here rather
// than displaying the impossible pair; the underlying data may still need fixing server-side, but
// the report itself always stays internally consistent.
export const getStatus = (completedDateTime, startedDateTime, hasAssessment, scorePercentage) => {
    const assessmentNotTaken = hasAssessment && !hasValue(scorePercentage);

    if (hasValue(completedDateTime) && !assessmentNotTaken) {
        return <span className="badge badge-success">Completed</span>
    }
    else if (!hasValue(startedDateTime) && !hasValue(scorePercentage)) {
        return <span className="badge badge-danger">Not Started</span>
    }
    else {
        return <span className="badge badge-warning">In Progress</span>
    }
}